import { CommandRoot } from "./command-root"
import { CommandDialog } from "./command-dialog"
import { CommandInput } from "./command-input"
import { CommandList } from "./command-list"
import { CommandEmpty } from "./command-empty"
import { CommandGroup } from "./command-group"
import { CommandItem } from "./command-item"
import { CommandSeparator } from "./command-separator"
import { CommandShortcut } from "./command-shortcut"
import { CommandHint } from "./command-hint"
import { CommandKbd } from "./command-kbd"

export type { CommandRootProps } from "./command-root"
export type { CommandDialogProps } from "./command-dialog"
export type { CommandInputProps } from "./command-input"
export type { CommandListProps } from "./command-list"
export type { CommandEmptyProps } from "./command-empty"
export type { CommandGroupProps } from "./command-group"
export type { CommandItemProps } from "./command-item"
export type { CommandSeparatorProps } from "./command-separator"
export type { CommandShortcutProps } from "./command-shortcut"
export type { CommandHintProps } from "./command-hint"
export type { CommandKbdProps } from "./command-kbd"

/**
 * A command menu (Cmd+K-style palette) built on `cmdk-base`, modeled after shadcn's
 * Command. Compose the pieces, or use `Command.Dialog` for the overlay variant.
 *
 * @example
 * ```tsx
 * <Command.Dialog open={open} onOpenChange={setOpen}>
 *   <Command.Input placeholder="Type to search..." />
 *   <Command.List>
 *     <Command.Empty>No results found.</Command.Empty>
 *     <Command.Group heading="Navigation">
 *       <Command.Item onSelect={() => go("/subscribers")}>Subscribers</Command.Item>
 *     </Command.Group>
 *   </Command.List>
 * </Command.Dialog>
 * ```
 */
export const Command = Object.assign(CommandRoot, {
  Dialog: CommandDialog,
  Input: CommandInput,
  List: CommandList,
  Empty: CommandEmpty,
  Group: CommandGroup,
  Item: CommandItem,
  Separator: CommandSeparator,
  Shortcut: CommandShortcut,
  Hint: CommandHint,
  Kbd: CommandKbd
} as const)
